<div class="section-list card card-main-section">
  <nav class="navbar navbar-expand-sm navbar-light bg-light justify-content-between section-header nav-2rows">
    <div class="section-header">
      <div class="section-icon"><i class="fa-eye far mr-1"></i> Supervision</div>
      <div class="section-detail sec-minwidth" *ngIf="ui_showCompany">
        <div class="section-detail-th"><i class="fas fa-industry"></i> Company</div>
        <div class="section-detail-td" matTooltip="{{site?.company?.name}}">{{site?.company?.name}}</div>
      </div>
      <div class="section-detail sec-minwidth">
        <div class="section-detail-th"><i class="fa-globe-americas fas"></i> Site</div>
        <div class="section-detail-td"><a
            (click)="gotohack($event,'/solar/site/'+ site?.id)" class="withpointer">{{site?.name}}</a></div>
      </div>
      <div class="section-detail sec-minwidth">
        <div class="section-detail-th"><i class="fa-eye far mr-1"></i> Supervision</div>
        <div class="section-detail-td section-detail-tit " matTooltip="{{supervision?.description}}">
          {{supervision?.name}}
        </div>
      </div>
      <div class="section-detail sec-minwidth">
        <div class="section-detail-th">On date</div>
        <div class="section-detail-td sm-1" matTooltip="Supervision execution day">
          {{supervision?.info?.supervisionDate | date:'dd-MM-yyyy'}}</div>
      </div>
      <div class="section-detail sec-minwidth">
        <div class="section-detail-th">Status</div>
        <div class="section-detail-td sm-1">
          <app-superv-status #supervisionstatus [supervision]="supervision" [status]="supervision?.info?.status">
          </app-superv-status>
        </div>
      </div>
      <div class="section-detail sec-minwidth">
        <div class="section-detail-th" matTooltip="Damaged modules"><i class="fas fa-th-large text-danger"></i> Damaged
          modules</div>
        <div class="section-detail-td sm-1 text-center">{{supervision?.info.errorsDetected }}</div>
      </div>
      <div class="section-detail sec-minwidth">
        <div class="section-detail-th">Last Modify</div>
        <div class="section-detail-td sm-1">{{supervision?.info?.updating_date | date:'dd-MM-yyyy HH:mm' }}</div>
      </div>
    </div>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <div class="ml-auto d-flex justify-content-end">
        <!--         <button class="btn btn-outline-primary " [(ngModel)]="mapVisible" btnCheckbox 
          role="button">Map</button>
          <button type="button" class="btn btn-outline-primary">Map</button>
          <button type="button" class="btn btn-outline-secondary">Secondary</button>
          <button type="button" class="btn btn-outline-success">Success</button>
          <button type="button" class="btn btn-outline-danger">Danger</button>
          <button type="button" class="btn btn-outline-warning">Warning</button>
          <button type="button" class="btn btn-outline-info">Info</button>
          <button type="button" class="btn btn-outline-light">Light</button>
          <button type="button" class="btn btn-outline-dark">Dark</button> -->

        <ul class="nav navbar-nav ml-auto" *ngIf="supervisionMapsVisible">
        </ul>
        <ul class="nav navbar-nav ml-auto">
          <li *ngIf="toolbaserSelected=='tab_issues'">
            <ul class="nav navbar-nav ml-auto">
              <li class="nav-item">
                <frms-searchbox
                  [tooltip]="'Enter panel name to find issue. Enter full panel name as you can see in list.'"
                  [placeholder]="'Find issue by panel'" (find_event)="findpanel_click_handler($event)"></frms-searchbox>
              </li>

              <li class="nav-item">
                <a class="nav-link" (click)="filterOpenModal()" matTooltip="Select filters for results"><i
                    class="fas fa-filter"></i> Filters</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" matTooltip="Show/Hide site vector panels" (click)="showSitePanels('TOGGLE')">
                  <i class="fas fa-solar-panel text-primary"></i> Panels
                </a>
              </li>
              <li class="nav-item" *ngIf="uiShowCarousselBtn()">
                <a class="nav-link" matTooltip="Show/Hide flight images gallery"
                  (click)="imagethumbgallery_show_click()">
                  <i class="far fa-images"></i> Gallery
                </a>

              </li>
            </ul>
          </li>
          <li class="nav-item dropdown" dropdown placement="bottom right">
            <a class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
              aria-expanded="false" dropdownToggle (click)="false">
              <i class="fas fa-ellipsis-v"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown1">
              <div class="dropdown-header">Supervision</div>
              <a class="dropdown-item" (click)="supervisionChangeStatus(supervisionstatus)"
                matTooltip="Change Status of supervision"><i class="fas fa-exchange-alt"></i> Change Status</a>
              <a class="dropdown-item" *ngIf="showReportButton" (click)="exportIssuesToExcel()"><i
                  class="fas fa-cloud-download-alt text-primary"></i>Generate Reports</a>

              <div *ngIf="showIssueToolbar" class="dropdown-header">Issues</div>
              <a class="dropdown-item" *ngIf="showIssueToolbar" (click)="refreshIssues();false"
                matTooltip="Refresh Issue data only">
                <i class="fas fa-sync"></i> Refresh issues</a>
              <a *ngIf="uiShowCarousselBtn()" class="dropdown-item" (click)="imagethumbgallery_show_click()">
                <app-check-box-icon [checked]="showCaroussel"></app-check-box-icon> Flight images caroussel
              </a>
              <a class="dropdown-item" *ngIf="showIssueToolbar" (click)="showSupervisionOptions()"><i
                  class="fa fa-cog"></i> Options</a>
            </div>
          </li>
        </ul>

      </div>
    </div>
  </nav>

  <div class="card-body">
    <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
    <app-frms-messagebar #messagebar *ngIf="alertmessage" [alertmessage]="alertmessage" [loading]="loadinglist">
    </app-frms-messagebar>
    <div class="overlay_spinner" *ngIf="!supervisionLoaded"></div>

    <div class="tab-custom">
      <tabset #tabgroup>
        <tab id="tab_supervisiondata" (selectTab)="onSelectTab($event)">
          <ng-template tabHeading>
            <i class="fas fa-dice-d6"></i> Supervision Data
          </ng-template>
          <app-ex-supervis-edit [supervision]="supervision" [selfload]="false"></app-ex-supervis-edit>
        </tab>
        <tab id="tab_supervisiondashboard" (selectTab)="onSelectTab($event)">
          <ng-template tabHeading>
            <i class="fa-tachometer-alt fas mr-1"></i> DashBoard
          </ng-template>
          <div *ngIf="showSupervisionDashboard">
            <app-site-superv [supervision]="supervision"></app-site-superv>
          </div>

        </tab>
        <tab id="tab_issues" (selectTab)="onSelectTab($event)">
          <ng-template tabHeading>
            <i class="fas fa-list"></i> Panel Issues
          </ng-template>
          <div class="tab-issues container-fluid pl-0 pr-0">
            <div class="row" *ngIf="supervisionMapsVisible">
              <div id="print-section" class="col-xl-6 col-sm-12 issues-section" [ngClass]="{ 'col-6, ': mapVisible }" [hidden]="!errorsVisible">
                <ng-template [ngIf]="uiShowIssueListType()" [ngIfElse]="issuelistvalidatorcomp">
                  <app-ex-issue-list #issuelistcomp [supervision]="supervision" [issuesOriginal]="issues"
                    [issues]="issuesFiltered" (issueSelectedEvent)="validator_issueSelectedEventHandler($event)">
                  </app-ex-issue-list>
                </ng-template>
                <ng-template #issuelistvalidatorcomp>
                  <ng-container *ngIf="componentStatus.data=='LOADED'">
                    <app-ex-issue-list-validator #issuelistcomp [supervision]="supervision" 
                      [issuesData]="validatorIssuesData"
                      [issuesOriginal]="issues"
                      [issuesFiltered]="issuesFiltered" [svFilter]="svFilter"
                      (issueSelectedEvent)="validator_issueSelectedEventHandler($event)"
                      (issueChangePanelInitiatorEvent)="validator_issueChangePanelInitiatorEventHandler($event)"
                      (filterChangedEvent)="validator_filterChangedEventHandler($event)"
                      (componentEvent)="validator_componentEventHandler($event)" [options]="issuesComponent_options">
                    </app-ex-issue-list-validator>
                  </ng-container>


                </ng-template>
              </div>

              <div [hidden]="!mapVisible" class="col-6 col-xl-6 col-sm-12">
                <div class="map-flex-container">
                  <app-imagethumbgallery *ngIf="showCaroussel" #imagethumbgallery [supervision]="supervision"
                    [load_type]="'FLIGHT'" [issueList]="issues" [issueSelected]="issueSelected"
                    (onThumbClick)="imagethumbgallery_thumbClick($event)"
                    (onThumbRightClick)="imagethumbgallery_thumbOnRightClick($event)"
                    (onClose)="imagethumbgallery_onClose($event)">
                  </app-imagethumbgallery>
                  <ng-container *ngIf="showMap">
                    <div [className]="!showCaroussel ? 'validator-map-container' : 'validator-map-container-reduced'">
                      <app-superv-map #supervmapcomp [supervision]="supervision" [options]="mapcomponent_options">
                      </app-superv-map>
                      <div #mapTooltip id="mapTooltip" class="map_tooltip" >TOOLTIP</div>
                    </div>
                  </ng-container>

                </div>
              </div>
            </div>
          </div>
        </tab>
        <tab *permusr="controlEnum.SEC_FLIGHT_OPERATOR" id="tab_flights" (selectTab)="onSelectTab($event)">
          <ng-template tabHeading>
            <i class="fas fa-list"></i> Flights
          </ng-template>
          <app-flight-main *ngIf="tab_showflights" [supervision]="supervision"></app-flight-main>

        </tab>
        <tab *permusr="controlEnum.SEC_SUPERVISION" id="tab_reports" (selectTab)="onSelectTab($event)">
          <ng-template tabHeading>
            <i class="far fa-file-excel"></i> Reports
          </ng-template>
          <app-rep-supervision [supervision]="supervision" [reports]="supervision?.info?.reports"></app-rep-supervision>
        </tab>
        <!--         <tab *permusr="controlEnum.SEC_SUPERVISION" id="tab_files" (selectTab)="onSelectTab($event)">
          <ng-template tabHeading>
            <i class="far fa-file-excel"></i> Attachments
          </ng-template>
          <app-superv-files [supervision]="supervision"></app-superv-files>
        </tab> -->
      </tabset>
    </div>

  </div>
</div>